import { QueryClient, QueryClientProvider, type DehydratedState, HydrationBoundary } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type FC, type ReactNode, useState } from 'react'

export interface ReactQueryProviderProps {
  children: ReactNode
  dehydratedState: DehydratedState
}

export const ReactQueryProvider: FC<ReactQueryProviderProps> = ({ children, dehydratedState }) => {
  const [client] = useState(() => new QueryClient())

  return (
    <QueryClientProvider client={client}>
      <ReactQueryDevtools
        buttonPosition='bottom-right'
        initialIsOpen={false}
      />
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
    </QueryClientProvider>
  )
}
